export const GET_MY_APPROVALS = "GET_MY_APPROVALS";
export const GET_BOARD_APPROVALS = "GET_BOARD_APPROVALS";
export const GET_APPROVAL_POLICIES = "GET_APPROVAL_POLICIES";
export const CREATE_APPROVAL_POLICY = "CREATE_APPROVAL_POLICY";
export const UPDATE_APPROVAL_POLICY = "UPDATE_APPROVAL_POLICY";
export const DELETE_APPROVAL_POLICY = "DELETE_APPROVAL_POLICY";
export const DECIDE_APPROVAL = "DECIDE_APPROVAL";
export const COMMENT_APPROVAL = "COMMENT_APPROVAL";
